import { diasUteis, isDiaUtil } from "../calculos";
import { F } from "../gerencialFields";
import { startOfDay, toDate } from "../status";
import {
  ETAPA,
  ORDEM_ETAPAS,
  saidaEtapa,
  saidaExpedicao,
} from "./etapas";

function subDiasUteis(date, dias, holidays = []) {
  if (!date) return null;
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  let removidos = 0;
  const total = Math.max(0, Math.ceil(dias));
  while (removidos < total) {
    result.setDate(result.getDate() - 1);
    if (isDiaUtil(result, holidays)) removidos++;
  }
  return result;
}

function deadlineDe(amb) {
  return (
    toDate(amb?.[F.DATA_REPROGRAMADA]) ||
    toDate(amb?.[F.ENTREGA_PREVISTA])
  );
}

export function calcularLeadTimesMedios(ambientesEntregues) {
  const lista = Array.isArray(ambientesEntregues) ? ambientesEntregues : [];
  const matriz = {};

  for (let i = 0; i < ORDEM_ETAPAS.length - 1; i++) {
    const a = ORDEM_ETAPAS[i];
    matriz[a] = {};
    for (let j = i + 1; j < ORDEM_ETAPAS.length; j++) {
      const b = ORDEM_ETAPAS[j];
      const valores = [];
      for (const amb of lista) {
        if (!saidaExpedicao(amb)) continue;
        const da = saidaEtapa(a, amb);
        const db = saidaEtapa(b, amb);
        if (!da || !db) continue;
        const dias = diasUteis(da, db);
        if (dias != null && dias >= 0) valores.push(dias);
      }
      if (valores.length) {
        matriz[a][b] = valores.reduce((sum, n) => sum + n, 0) / valores.length;
      }
    }
  }

  return matriz;
}

export function dataLimiteLiberacao(
  amb,
  { ccrEtapa = ETAPA.MARCENARIA, leadTimesMedios } = {}
) {
  const entrega = deadlineDe(amb);
  if (!entrega) return null;

  const leadComprasParaEntrega =
    leadTimesMedios?.[ETAPA.COMPRAS]?.[ETAPA.EXPEDICAO];
  const leadCcrParaEntrega = leadTimesMedios?.[ccrEtapa]?.[ETAPA.EXPEDICAO];
  const leadComprasParaCcr = leadTimesMedios?.[ETAPA.COMPRAS]?.[ccrEtapa];

  if (
    leadCcrParaEntrega != null &&
    leadComprasParaCcr != null
  ) {
    const dataAlvoCcr = subDiasUteis(entrega, leadCcrParaEntrega);
    if (!dataAlvoCcr) return null;
    return subDiasUteis(dataAlvoCcr, leadComprasParaCcr);
  }

  if (leadComprasParaEntrega != null) {
    return subDiasUteis(entrega, leadComprasParaEntrega);
  }

  return null;
}

export function proximasLiberacoes(
  ambientesEmCompras,
  { hoje = new Date(), ccrEtapa, leadTimesMedios, limite = 10 } = {}
) {
  const today = startOfDay(hoje) || new Date();
  const lista = Array.isArray(ambientesEmCompras) ? ambientesEmCompras : [];

  const enriquecidos = lista
    .map((amb) => {
      const dataLimite = dataLimiteLiberacao(amb, {
        ccrEtapa,
        leadTimesMedios,
      });
      const margem = dataLimite ? diasUteis(today, dataLimite) : null;
      return { amb, dataLimite, margem };
    })
    .filter((item) => item.dataLimite);

  enriquecidos.sort((left, right) => {
    if (!left.dataLimite) return 1;
    if (!right.dataLimite) return -1;
    return left.dataLimite - right.dataLimite;
  });

  return enriquecidos.slice(0, limite);
}
